// extracted by mini-css-extract-plugin
export default {"list":"list--61iGCd+dVW"};